import type { Coordinates } from "./types";

export interface CampusConfig {
  id: string;
  name: { en: string; th: string; zh: string };
  center: Coordinates;
  innerBounds: [Coordinates, Coordinates];
  outerBounds: [Coordinates, Coordinates];
  surroundingRoads: string[];
  defaultView: {
    longitude: number;
    latitude: number;
    zoom: number;
    pitch: number;
    bearing: number;
  };
}

export const MTT: CampusConfig = {
  id: "muang-thong-thani",
  name: {
    en: "Muang Thong Thani",
    th: "เมืองทองธานี",
    // NOTE: phonetic transliteration — verify against IMPACT's official zh assets.
    zh: "通堂他尼",
  },
  // เมืองทองธานี (Muang Thong Thani) — ~4,500 rai / 7.2 km², Pak Kret, Nonthaburi.
  // Thailand's largest PRIVATE satellite city, developed by Bangkok Land. Anchored
  // by IMPACT (Challenger / Arena / Forum — 15M visitors/yr), ringed by 27 Popular
  // Condo towers + Lakeside blocks, two flood-control lakes (381 rai), and the
  // Chaeng Watthana Government Complex on its southern edge. The MRT Pink Line spur
  // (MT01/MT02) finally connected it in 2025 after ~35 years as a transit desert.
  center: [100.545, 13.9145], // [lng, lat] — IMPACT / MTT core
  innerBounds: [
    [100.530, 13.902], // SW — the MTT core + IMPACT halls + lakes
    [100.560, 13.927], // NE
  ],
  outerBounds: [
    [100.512, 13.886], // overscroll to the Government Complex, Pink Line PK10, expressway
    [100.578, 13.942],
  ],
  surroundingRoads: [
    "Chaeng Watthana Road", // primary arterial to Bangkok
    "Popular Road",         // MTT internal spine (Immigration HQ, Bangkok Land)
    "Bond Street",          // internal north-south route
    "Tiwanon Road",         // western connector
    "Udon Ratthaya Expressway", // Bang Pa-in - Pak Kret tollway
  ],
  // bearing 0, pitch 56° — extrudes the IMPACT halls and condo towers without
  // tilting so far that the lakes and the Government Complex slide off frame.
  defaultView: {
    longitude: 100.545,
    latitude: 13.9145,
    zoom: 14.4,
    pitch: 56,
    bearing: 0,
  },
};

// Legacy aliases — keep stray YALA/CHONBURI/CHULA references building.
export const YALA = MTT;
export const CHONBURI = MTT;
export const CHULA = MTT;
